import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const strict = false
export const sendbird = {
  namespaced: true,
  scrict: false,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/index.js